<template>
  <div class="home-page w-100 h-100 flex-vertical text-title">
    <header class="flex-header flex-item align-items-center justify-content-between w-100 px-5 py-1 border-box bg-dark color-common font">
      <div class="flex-label d-flex align-items-center">
        <img class="logo" src="@/assets/img/logo.png" alt="">
        <div class="ml-2 title">FOMOSHIBA TOKEN</div>
      </div>
      <div class="flex-content flex-item justify-content-end ml-2">
        <el-button :loading="initLoading" class="ellipsis-text" size="mini" :disabled="!!account" @click="onConnect">
          <template v-if="account === 'wrong'">{{ $t('home.wrong') }}</template>
          <template v-else>{{ account || $t('home.connect') }}</template>
        </el-button>
      </div>
      <div class="flex-item align-items-center">
        <div class="tab-box d-flex align-items-center ml-2">
          <div class="px-3 tab-item">
            <a href="#ecosystem">{{ $t('home.intro') }}</a>
          </div>
          <div class="px-3 tab-item">
            <a href="#buy">{{ $t('home.buy') }}</a>
          </div>
        </div>
        <div class="position-relative language-box ml-4 cursor-pointer d-flex align-items-center">
          <svg t="1639222400139" class="pr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2110" width="2rem" height="2rem"><path d="M512.9 960.2c-245.5 0-445.3-199.8-445.3-445.3S267.4 69.6 512.9 69.6c97.2 0 189.6 30.8 267.1 89 15.1 11.4 18.2 32.8 6.8 48-11.4 15.1-32.8 18.2-48 6.8-65.6-49.2-143.7-75.2-226-75.2C305 138.2 136 307.2 136 515s169 376.8 376.8 376.8 376.8-169 376.8-376.8c0-48.5-9.1-95.8-27-140.4-7.1-17.6 1.5-37.5 19-44.6 17.6-7.1 37.5 1.5 44.6 19 21.2 52.8 32 108.6 32 165.9 0 245.6-199.7 445.3-445.3 445.3z" fill="#b8add2" p-id="2111"></path><path d="M829.1 273.3m-39.5 0a39.5 39.5 0 1 0 79 0 39.5 39.5 0 1 0-79 0Z" fill="#b8add2" p-id="2112"></path><path d="M523.6 954.4c-6.3 0-12.6-2.2-17.8-6.6-16.1-13.7-31.6-28.6-46.1-44.3-45.5-48.9-81.4-104.9-106.8-166.5-27.4-66.3-41.4-136.5-41.9-208.8v-3.5c0-61.6 10.1-122.2 29.8-180 28.8-84.1 78.2-161.2 143-222.8 4.9-4.7 10-9.3 15.1-13.8 11.3-10 28.7-9 38.7 2.4 10 11.3 9 28.7-2.4 38.7-4.6 4.1-9.2 8.3-13.6 12.5-58.3 55.6-102.9 125-128.9 200.8-17.8 52.1-26.9 106.7-26.9 162.3v3.3c0.4 65 13.1 128.3 37.7 188 22.9 55.5 55.3 106 96.3 150.1 13.1 14.2 27.1 27.6 41.5 39.9 11.5 9.8 12.9 27.1 3 38.6-5.2 6.4-12.9 9.7-20.7 9.7z" fill="#b8add2" p-id="2113"></path><path d="M487.4 953.1c-8.4 0-16.6-3.8-22-11-9.1-12.1-6.6-29.3 5.6-38.4 16-11.9 31.4-25 45.9-38.7 43.8-41.7 79.3-90.2 105.5-144.3 29.6-60.8 46.3-126.1 49.6-193.9 0.4-8.5 0.6-16.9 0.6-25 0-43.4-5.5-86.6-16.5-128.1-20.8-79.2-61.5-153-117.5-213.3-4-4.4-8.3-8.8-13.2-13.7-10.7-10.7-10.8-28-0.1-38.8 10.7-10.7 28-10.8 38.8-0.1 5.6 5.5 10.4 10.6 14.9 15.5 62 66.7 107.1 148.5 130.2 236.5 12.1 46.1 18.3 93.9 18.3 142.1 0 9-0.2 18.3-0.7 27.6-3.7 75.3-22.2 147.7-55.1 215.2-29.1 60-68.5 113.8-117 160-16 15.3-33.1 29.7-50.9 42.9-5 3.7-10.7 5.5-16.4 5.5z" fill="#b8add2" p-id="2114"></path><path d="M834.9 747.1c-5.3 0-10.7-1.5-15.4-4.8-58.1-39.7-122.1-67.9-190.2-83.9-42.6-10-86.6-15.1-130.8-15.1h-0.2c-33.2 0-66.3 2.8-98.6 8.5-73 12.7-142 39.3-204.9 78.9-12.8 8.1-29.7 4.2-37.8-8.6-8.1-12.8-4.2-29.7 8.6-37.8 69-43.4 144.6-72.5 224.7-86.5 35.4-6.2 71.7-9.3 108-9.3h0.2c48.4 0 96.6 5.6 143.3 16.6 74.7 17.5 144.9 48.5 208.6 92 12.5 8.5 15.7 25.6 7.2 38.1-5.4 7.7-14 11.9-22.7 11.9zM924 480.5l-801.8-0.3c-15.1 0-27.4-12.3-27.4-27.4 0-15.1 12.3-27.4 27.4-27.4l801.8 0.3c15.1 0 27.4 12.3 27.4 27.4 0 15.2-12.3 27.4-27.4 27.4z" fill="#b8add2" p-id="2115"></path></svg>
          <div>{{ returnLanguageName }}</div>
          <div class="language-content">
            <div v-for="(item, index) in languageList" :key="index" class="language-item d-flex justify-content-center align-items-center cursor-pointer" :class="{ 'active': item.value === language }" @click="switchLanguage(item.value)">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </header>
    <main class="flex-content slim-no-scroll">
      <section class="banner-wrapper px-5 font d-flex align-items-end">
        <div class="left-box pb-5 pr-5">
          <div class="title color-deep text-max">{{ $t('home.bannerText1') }}</div>
          <div class="line-sm mt-4">{{ $t('home.bannerText2') }}</div>
          <div class="mt-5 pt-3">
            <el-button>
              <a href="#buy">{{ $t('home.howToBuy') }}</a>
            </el-button>
            <el-button plain disabled>{{ $t('home.readWhite') }}</el-button>
          </div>
        </div>
        <div class="right-box d-flex justify-content-center">
          <div class="img-box">
            <img class="logo" src="@/assets/img/logo_l.png" alt="">
            <img class="star star1" src="@/assets/img/star.png" alt="">
            <img class="star star2" src="@/assets/img/star.png" alt="">
            <img class="star star3" src="@/assets/img/star.png" alt="">
          </div>
        </div>
      </section>
      <section id="ecosystem" class="project-wrapper px-5 text-center font">
        <div class="bg-box"></div>
        <div class="content-box">
          <div>
            <img class="logo-img" src="@/assets/img/logo.png" alt="">
          </div>
          <div class="text-max">{{ $t('home.intro') }}</div>
          <div class="mt-5 color-common text-main line-sm px-5">
            <span>{{ $t('home.introDes') }}</span>
          </div>
          <div class="mt-3 color-common text-main line-sm px-5">
            <span class="color-white">{{ $t('home.about') }}</span>
            <span>{{ $t('home.aboutDes') }}</span>
          </div>
          <div class="card-box d-flex mt-5 text-lg">
            <div class="card-item">
              <div class="card-content py-5">
                <svg t="1639296056117" class="mb-4" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6868" width="6.8rem" height="6.8rem"><path d="M801.5 925H226.4c-69.9 0-126.8-56.9-126.8-126.8V225.3c0-69.9 56.9-126.8 126.8-126.8h575.1c69.9 0 126.8 56.9 126.8 126.8v91.1c0 24.7-20.1 44.8-44.8 44.8-24.7 0-44.8-20.1-44.8-44.8v-91.1c0-20.5-16.7-37.2-37.2-37.2H226.4c-20.5 0-37.2 16.7-37.2 37.2v572.9c0 20.5 16.7 37.2 37.2 37.2h575.1c20.5 0 37.2-16.7 37.2-37.2V486.5c0-24.7 20.1-44.8 44.8-44.8 24.7 0 44.8 20.1 44.8 44.8v311.8c0 69.9-56.9 126.7-126.8 126.7z" fill="#9a6aff" p-id="6869"></path><path d="M883.5 522.3h-476c-69.1 0-125.4-56.2-125.4-125.4s56.2-125.4 125.4-125.4h282.9c46.5 0 84.3 37.8 84.3 84.3v76.8h108.8c24.7 0 44.8 20.1 44.8 44.8 0 24.9-20.1 44.9-44.8 44.9z m-476-161.1c-19.7 0-35.8 16.1-35.8 35.8 0 19.7 16 35.8 35.8 35.8h277.6v-71.5H407.5z" fill="#9a6aff" p-id="6870"></path></svg>
                <div>
                  <div>{{ $t('home.cardLine1') }}</div>
                  <div class="second-row mt-2">{{ $t('home.cardLine2') }}</div>
                </div>
              </div>
            </div>
            <div class="card-item">
              <div class="card-content py-5">
                <svg t="1639296103304" class="mb-4" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7118" width="6.8rem" height="6.8rem"><path d="M742.389 942.887H292.133c-124.143 0-225.128-100.985-225.128-225.128V305.024c0-124.134 100.985-225.128 225.128-225.128H742.39c124.143 0 225.128 100.994 225.128 225.128v412.735c-0.001 124.143-100.986 225.128-225.129 225.128zM292.133 154.938c-82.756 0-150.086 67.33-150.086 150.086v412.735c0 82.756 67.33 150.086 150.086 150.086H742.39c82.756 0 150.086-67.33 150.086-150.086V305.024c0-82.756-67.33-150.086-150.086-150.086H292.133z" fill="#5bb2da" p-id="7119"></path><path d="M586.038 332.23H271.576c-20.721 0-37.521-16.8-37.521-37.521s16.8-37.521 37.521-37.521h314.461c20.721 0 37.521 16.8 37.521 37.521s-16.799 37.521-37.52 37.521z" fill="#5bb2da" p-id="7120"></path><path d="M967.517 726.205H708.44c-82.756 0-150.086-67.33-150.086-150.086v-11.258c0-82.756 67.33-150.086 150.086-150.086h259.077v311.43zM708.44 489.818c-41.387 0-75.043 33.665-75.043 75.043v11.258c0 41.378 33.656 75.043 75.043 75.043h184.034V489.818H708.44z" fill="#5bb2da" p-id="7121"></path></svg>
                <div>
                  <div>{{ $t('home.cardLine3') }}</div>
                  <div class="second-row mt-2">{{ $t('home.cardLine4') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="coin-wrapper px-5 color-white d-flex font">
          <div class="coin-content px-4 py-5 flex-item">
            <div class="left-box flex-item align-items-center justify-content-center">
              <img src="@/assets/img/coin2.png" alt="">
            </div>
            <div class="right-box flex-content pl-5">
              <div class="title">FOMOSHIB</div>
              <div class="mt-4 line-sm">{{ $t('home.fomoIntro') }}</div>
              <div class="mt-3 line-sm">
                <span>{{ $t('home.fomoDes1') }}</span>
                <span>{{ $t('home.fomoDes2') }}</span>
              </div>
              <div class="mt-5">
                <el-button class="buy-button">
                  <a href="https://pancakeswap.finance/swap#/swap">{{ $t('home.buy') }} FOMOSHIB</a>
                </el-button>
              </div>
            </div>
          </div>
      </section>
      <section id="buy" class="buy-wrapper px-5 color-white font d-flex">
        <div class="left-box">
          <div class="text-max mb-5">
            <span class="color-deep">{{ $t('home.howToBuy') }}</span>
          </div>
          <div class="line-sm">{{ $t('home.buyWay') }}</div>
          <div class="mt-4 line-sm">{{ $t('home.buySug') }}</div>
          <div class="mt-3">
            <el-button class="buy-button mt-3 mr-3 ml-0">
              <a href="https://pancakeswap.finance/swap#/swap">{{ $t('home.buy') }} FOMOSHIB</a>
            </el-button>
          </div>
        </div>
        <div class="right-box text-right">
          <img src="~@/assets/img/coin_r.png" alt="">
        </div>
      </section>
      <section class="center-wrapper px-5 font">
        <div class="center-box round-md px-5 py-5 text-main">
          <div class="mb-4">
            <div class="font-weight-bold text-md flex-item align-items-center justify-content-center">
              <div class="flex-content flex-item align-items-center justify-content-end">
                <div class="flex-label">{{ $t('home.buyAddress') }}：</div>
                <div class="address-box position-relative flex-content ellipsis-text">
                  <div class="cover"></div>
                  <input type="text" class="address-copy w-100 ellipsis-text" :value="contractAddr">
                </div>
              </div>
              <el-button plain class="flex-label ml-3" @click="onCopyAddress">{{ $t('home.copy') }}</el-button>
            </div>
          </div>
          <div class="num-content flex-item mb-4 text-center">
            <div class="num-line flex-content">
              <div class="color-common mb-2">{{ $t('home.totalNum') }}</div>
              <div class="text-lg font-weight-bold break-word">{{ numObj.totalNum | toThousands }}</div>
            </div>
            <div class="num-line flex-content">
              <div class="color-common mb-2">{{ $t('home.leftNum') }}</div>
              <div class="text-lg font-weight-bold break-word">{{ numObj.leftNum | toThousands(true) }}</div>
            </div>
            <div class="num-line flex-content">
              <div class="color-common mb-2">{{ $t('home.destoryNum') }}</div>
              <div class="text-lg font-weight-bold break-word">{{ numObj.destoryNum | toThousands(true) }}</div>
            </div>
          </div>
          <div class="flex-item align-items-center">
            <div class="flex-content">
              <el-input class="destory-input round" v-model="destoryVal"></el-input>
            </div>
            <div class="flex-label pl-3">
              <el-button @click="onDestory" :loading="destoryLoading">{{ $t('home.destory') }}</el-button>
            </div>
          </div>
          <div class="flex-item align-items-center mt-2">
            <div>{{ $t('home.balance') }}{{ numObj.balance || '--' }}</div>
            <div class="ml-4">{{ $t('home.price') }}{{ numObj.price || '--' }}</div>
          </div>
        </div>
      </section>
      <section class="guide-wrapper px-5 font">
        <div class="text-max text-center">{{ $t('home.startGuide') }}</div>
        <div class="content-box flex-item align-items-center mt-5 pt-5">
          <div class="text-box w-50 flex-content">
            <div class="text-row">
              <div class="row-title bg-deep">step 1</div>
              <div class="text-lg">{{ $t('home.stepTitle1') }}</div>
              <div class="color-common mt-4 line-sm text-item">{{ $t('home.stepDes1') }}</div>
            </div>
            <div class="text-row mt-5 pt-5">
              <div class="row-title bg-deep">step 2</div>
              <div class="text-lg">{{ $t('home.stepTitle2') }}</div>
              <div class="color-common mt-4 line-sm text-item">{{ $t('home.stepDes2') }}</div>
            </div>
          </div>
          <div class="line-box flex-label px-4">
            <div class="line-item tl"><div class="line"></div></div>
            <div class="line-item bl"><div class="line"></div></div>
          </div>
          <div class="logo-box flex-label">
            <img class="logo" src="@/assets/img/guide_logo.png" alt="">
          </div>
          <div class="line-box flex-label px-4">
            <div class="line-item tr"><div class="line"></div></div>
            <div class="line-item br"><div class="line"></div></div>
          </div>
          <div class="text-box w-50 flex-content">
            <div class="text-row">
              <div class="row-title bg-deep">step 3</div>
              <div class="text-lg">{{ $t('home.stepTitle3') }}</div>
              <div class="color-common mt-4 line-sm text-item">{{ $t('home.stepDes3') }}</div>
            </div>
            <div class="text-row mt-5 pt-5">
              <div class="row-title bg-deep">step 4</div>
              <div class="text-lg">{{ $t('home.stepTitle4') }}</div>
              <div class="color-common mt-4 line-sm text-item">{{ $t('home.stepDes4') }}</div>
            </div>
          </div>
        </div>
      </section>
      <section class="art-wrapper px-5 font">
        <div class="art-content">
          <div class="text-max text-center">{{ $t('home.art') }}</div>
          <div class="line-sm mt-5 pt-4">{{ $t('home.artDes') }}</div>
          <div class="swiper-container position-relative mt-3">
            <div class="swiper-wrapper">
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon1.png" alt="">
              </div>
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon2.png" alt="">
              </div>
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon3.png" alt="">
              </div>
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon4.png" alt="">
              </div>
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon5.png" alt="">
              </div>
              <div class="swiper-slide p-2 text-zero">
                <img class="w-100" src="@/assets/img/icon6.png" alt="">
              </div>
            </div>
            <div class="swiper-button-prev" @click="onPrev"></div>
            <div class="swiper-button-next" @click="onNext"></div>
          </div>
        </div>
      </section>
      <section class="community-wrapper font">
        <div class="text-max text-center mb-5">{{ $t('home.community') }}</div>
        <div class="content-box">
          <div class="text-box line-sm text-center">
            <span>{{ $t('home.communityDes') }}</span>
            <span class="color-warning"> BNB, FOMOSHIB, USDT {{ $t('home.or') }} ETH </span>
            <span>{{ $t('home.communityThank') }}</span>
          </div>
          <div class="recom-box mt-5 flex-item align-items-center">
            <div class="flex-content position-relative">
              <div class="cover"></div>
              <input type="text" class="copy-input ellipsis-text" :value="copyVal">
            </div>
            <div class="flex-label pl-5">
              <el-button plain @click="onCopy">{{ $t('home.copy') }}</el-button>
            </div>
          </div>
        </div>
      </section>
      <section class="intro-wrapper px-5 font line-sm text-center">
        <div class="color-light">{{ $t('home.starDes') }}</div>
        <div class="color-light mt-4">{{ $t('home.linkDes') }}</div>
        <div class="my-5 color-deep cursor-pointer" @click="visible = true">{{ $t('home.clickDes') }}</div>
        <div class="icon-box d-flex justify-content-around mb-5 pb-5">
          <a href="" target="_blank" class="icon-item">
            <svg t="1639314551720" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8745" width="4.5rem" height="4.5rem"><path d="M565.747623 792.837176l260.819261 112.921839 126.910435-845.424882L66.087673 581.973678l232.843092 109.933785 562.612725-511.653099-451.697589 563.616588-5.996574 239.832274L565.747623 792.837176z" p-id="8746"></path></svg>
          </a>
          <a href="" target="_blank" class="icon-item">
            <svg t="1639314635776" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9261" width="4.5rem" height="4.5rem"><path d="M919.759462 318.994613c0-9.605475-0.184234-19.102577-0.608696-28.534655 41.060787-30.595551 76.68666-68.894629 104.863684-112.720738a403.247526 403.247526 0 0 1-120.68436 33.017692c43.401647-26.708567 76.68666-69.423851 92.415219-120.68436-40.638132 24.645865-85.589515 42.265535-133.383889 51.446549-38.295465-43.575045-92.944441-71.329413-153.358869-72.360764-116.027926-1.918205-210.084998 96.132418-210.084999 218.973404 0 17.460724 1.826088 34.394031 5.451171 50.745736-174.722834-11.243716-329.55016-102.190479-433.116978-239.293373-18.071226 32.847907-28.438925 71.237296-28.438925 112.377556 0 77.811934 37.090717 146.970271 93.44657 187.779994-34.500598-1.560574-66.819283-12.009553-95.166091-29.141545v2.85744c0 108.752474 72.440238 199.870827 168.560013 221.13003-17.621477 5.012259-36.207475 7.62044-55.322696 7.526516a191.542349 191.542349 0 0 1-39.500214-4.325895c26.708567 89.120675 104.332655 154.231274 196.231295 156.400543-71.923659 59.635948-162.525433 95.258208-260.892145 95.00895-16.960401 0-33.720311-1.137918-50.15149-3.200621 93.011271 63.80109 203.418242 100.960443 322.104923 100.960443 386.350343 0.092117 597.636477-336.191629 597.636477-627.962902z" p-id="9262"></path></svg>
          </a>
          <!-- <div class="icon-item">
            <svg t="1639314914309" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10496" width="4.5rem" height="4.5rem"><path d="M860.414581 207.449017 509.333781 207.449017c0-52.808332-43.003528-95.81186-95.81186-95.81186l-63.817235 0c-52.808332 0-95.81186 43.003528-95.81186 95.81186L158.424996 207.449017c-52.808332 0-95.81186 43.003528-95.81186 95.81186l0 510.53788c0 52.808332 43.003528 95.81186 95.81186 95.81186l701.989585 0c52.808332 0 95.81186-43.003528 95.81186-95.81186L956.22644 303.260877C956.054426 250.452545 913.050899 207.449017 860.414581 207.449017zM509.333781 749.981522c-105.616664 0-191.451705-85.835041-191.451705-191.451705s85.835041-191.451705 191.451705-191.451705 191.451705 85.835041 191.451705 191.451705S614.950445 749.981522 509.333781 749.981522zM812.422644 430.895347c-26.490173 0-47.819923-21.501764-47.819923-47.819923s21.501764-47.819923 47.819923-47.819923c26.490173 0 47.819923 21.501764 47.819923 47.819923S838.912817 430.895347 812.422644 430.895347z" p-id="10497"></path></svg>
          </div>
          <div class="icon-item">
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" width="4.5rem"><path d="M12.09 13.412c-.448.447-1.408.607-2.09.607-.682 0-1.642-.16-2.09-.607a.27.27 0 00-.383 0 .27.27 0 000 .383c.714.704 2.068.757 2.473.757.405 0 1.76-.053 2.473-.767a.27.27 0 000-.384.28.28 0 00-.383.01zM8.753 11.034c0-.576-.47-1.045-1.045-1.045-.576 0-1.045.47-1.045 1.045 0 .576.47 1.045 1.045 1.045.576 0 1.045-.47 1.045-1.045z"></path><path d="M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.467 10-10c-.01-5.522-4.478-10-10-10zm5.8 11.333c.02.138.032.287.032.437 0 2.25-2.612 4.062-5.832 4.062-3.22 0-5.832-1.813-5.832-4.062 0-.15.011-.299.032-.437A1.447 1.447 0 013.337 10 1.463 1.463 0 015.81 8.945c1.013-.736 2.41-1.194 3.966-1.237 0-.021.736-3.486.736-3.486 0-.064.042-.128.096-.16a.263.263 0 01.202-.043l2.42.523c.17-.342.523-.587.928-.587A1.04 1.04 0 0115.203 5a1.04 1.04 0 01-1.045 1.045 1.034 1.034 0 01-1.034-.992l-2.175-.469-.661 3.124c1.535.053 2.91.522 3.902 1.237a1.454 1.454 0 012.473 1.044 1.48 1.48 0 01-.863 1.344z"></path><path d="M12.292 10c-.576 0-1.045.47-1.045 1.045s.47 1.045 1.045 1.045c.576 0 1.045-.47 1.045-1.045A1.06 1.06 0 0012.292 10z"></path></svg>
          </div>
          <div class="icon-item">
            <svg viewBox="0 0 20 16" width="4.5rem" xmlns="http://www.w3.org/2000/svg"><path d="M16.93 1.644A16.491 16.491 0 0012.86.38a.062.062 0 00-.066.031c-.175.313-.37.72-.506 1.041a15.226 15.226 0 00-4.573 0A10.54 10.54 0 007.2.412a.064.064 0 00-.065-.031 16.447 16.447 0 00-4.07 1.263.058.058 0 00-.028.023C.444 5.54-.266 9.319.083 13.05a.069.069 0 00.026.047 16.584 16.584 0 004.994 2.525.064.064 0 00.07-.023c.385-.526.728-1.08 1.022-1.662a.063.063 0 00-.035-.088 10.917 10.917 0 01-1.56-.744.064.064 0 01-.007-.106c.105-.079.21-.16.31-.243a.062.062 0 01.065-.009c3.273 1.495 6.817 1.495 10.051 0a.062.062 0 01.066.008c.1.083.204.165.31.244a.064.064 0 01-.005.106c-.499.291-1.017.537-1.561.743a.064.064 0 00-.034.089c.3.582.643 1.135 1.02 1.66a.063.063 0 00.07.025 16.53 16.53 0 005.003-2.525.064.064 0 00.026-.046c.417-4.314-.699-8.061-2.957-11.384a.05.05 0 00-.026-.023zM6.684 10.778c-.985 0-1.797-.905-1.797-2.016 0-1.11.796-2.015 1.797-2.015 1.01 0 1.814.912 1.798 2.015 0 1.111-.796 2.016-1.798 2.016zm6.646 0c-.986 0-1.797-.905-1.797-2.016 0-1.11.796-2.015 1.797-2.015 1.009 0 1.813.912 1.797 2.015 0 1.111-.788 2.016-1.797 2.016z"></path></svg>
          </div> -->
        </div>
        <div class="color-common">© 2021 - 2026 Binance.org. All rights reserved.</div>
      </section>
    </main>
    <footer class="flex-footer w-100 px-5 py-1 border-box bg-dark color-common font">
      <div class="tab-box d-flex align-items-center justify-content-around">
        <div class="px-3 tab-item">
          <a href="#ecosystem">{{ $t('home.intro') }}</a>
        </div>
        <div class="px-3 tab-item">{{ $t('home.buy') }}</div>
      </div>
    </footer>

    <transition name="move">
      <div v-if="visible" class="link-dialog">
        <h3 class="color-warning">
          Telegram {{ $t('home.group') }}
          <i class="el-icon-close font-weight-bold text-add cursor-pointer" @click="visible = false"></i>
        </h3>
        <ul>
          <li><a href="" target="_blank">Fomoshiba English Group</a></li>
          <li class="mt-3"><a href="https://t.me/+I4ArWPvKHZYwN2Y1" target="_blank">Fomoshiba 中文群</a></li>
        </ul>
      </div>
    </transition>

    <transition name="fade">
      <section v-if="visible" class="dialog-cover"></section>
    </transition>
  </div>
</template>

<script>
import { getAttr, InitWeb, tokenInfo, activeBurn } from '../method/methos';
import Swiper from 'swiper';
import "swiper/css/swiper.min.css";

export default {
  name: 'Home',
  data() {
    return {
      initLoading: true,
      account: '',
      language: "",
      languageList: [
        { name: '中文', value: 'zh' },
        { name: 'English', value: 'en' }
      ],
      contractAddr: '--',
      destoryVal: '',
      destoryLoading: false,
      numObj: {
        totalNum: '',
        leftNum: '',
        destoryNum: '',
        balance: '',
        price: ''
      },
      swiper: '',
      copyVal: '0x0dFA10ae47B4989f1892668B89156E22E32983d4',
      visible: false
    }
  },
  computed: {
    returnLanguageName() {
      const { language, languageList } = this;
      if (!language) return '--';
      //console.log(this.language,languageList)
      return languageList.find((item) => item.value === language).name;
    }
  },
  created() {
    this.language = localStorage.getItem("languageStorage") || "en";
    this.contractAddr = getAttr();
    this.onConnect();
  },
  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      loop: true,
      slidesPerView: 3,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
		});
  },
  filters: {
    toThousands(num, key) {
      if (num === '') return '--';
      if (num >= 1000) num = num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return key ? `≈ ${num}` : num;
    }
  },
  methods: {
    async onConnect() {
      const account = await InitWeb();
      this.initLoading = false;
      console.log(account, '---')
      if (account) {
        this.account = account;
        this.numObj = await tokenInfo();
      } else {
        this.account = 'wrong';
      }
    },
    switchLanguage(language) {
      this.language = language;
      this.$i18n.locale = language;
      localStorage.setItem("languageStorage", language);
    },
    onPrev() {
      this.swiper.slidePrev();
    },
    onNext() {
      this.swiper.slideNext();
    },
    onCopyAddress() {
      const input = document.getElementsByClassName('address-copy')[0];
      input.select();
      if (document.execCommand) {
        document.execCommand('copy');
        this.$message.success(this.$t('home.copySuccess'));
      }
    },
    onCopy() {
      const input = document.getElementsByClassName('copy-input')[0];
      input.select();
      if (document.execCommand) {
        document.execCommand('copy');
        this.$message.success(this.$t('home.copySuccess'));
      }
    },
    async onDestory() {
      if (!this.destoryVal) return this.$message.warning(this.$t('home.pleaseEnter'));
      this.destoryLoading = true;
      await activeBurn(this.destoryVal);
      this.destoryLoading = false;
    }
  }
}
</script>

<style lang="less" scoped>

@keyframes shrink {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  75% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
  }
}

@import '~@/assets/style/variable.less';

header {
  border-bottom: 1px solid @colorShadow;
  .logo {
    width: 2.6rem;
  }
  .language-box {
    .language-content {
      position: absolute;
      top: 2.8rem;
      right: 0;
      padding: 1rem;
      background: @colorDark;
      height: 0;
      opacity: 0;
      transition: all ease-in-out 400ms;
      width: 6.6rem;
      .language-item {
        height: 3rem;
        color: @colorCommon;
        &.active, &:hover {
          color: @colorDeep;
          font-weight: bold;
        }
      }
    }
    &:hover {
      .language-content {
        height: 6rem;
        opacity: 1;
      }
    }
  }
}

header, footer {
  .tab-box {
    height: 3rem;
    line-height: 3rem;
    .tab-item {
      cursor: pointer;
      &:hover {
        color: @colorDeep;
        background: @colorShadow;
        border-radius: 0.8rem;
      }
      a {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
}

main {
  .banner-wrapper {
    padding-top: 6.6rem;
    padding-bottom: 6.6rem;
    background: linear-gradient(to right, #313d5c 0%, #3d2a54 100%);
    background: url('~@/assets/img/banner.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .left-box {
      width: 60%;
      .title {
        line-height: 4rem;
      }
    }
    .right-box {
      width: 40%;
      height: 100%;
      margin-bottom: -14rem;
      .img-box {
        position: relative;
        .logo {
          width: 30rem;
        }
        .star {
          position: absolute;
          opacity: 0;
          &.star1 {
            top: 1rem;
            left: 0;
            width: 3rem;
            transform: rotate(-30deg);
            animation: shrink 4.5s linear 0.5s infinite;
          }
          &.star2 {
            top: -5rem;
            right: 5rem;
            width: 5rem;
            animation: shrink 4.5s linear 1s infinite;
          }
          &.star3 {
            bottom: 30%;
            right: 2rem;
            width: 4rem;
            transform: rotate(10deg);
            animation: shrink 4.5s linear 1.5s infinite;
          }
        }
      }
    }
  }

  .project-wrapper {
    position: relative;
    margin-top: 15rem;
    padding-bottom: 10rem;
    .bg-box {
      position: absolute;
      left: 50%;
      bottom: 0;
      z-index: 1;
      width: 150%;
      height: 100%;
      transform: translate(-50%, 0) rotate(3deg);
      background: linear-gradient(to top, #201434 0%,  @colorBg 100%);
    }
    .content-box {
      position: relative;
      z-index: 2;
      .logo-img {
        width: 3rem;
      }
      .card-box {
        .card-item {
          width: 33%;
          flex-grow: 1;
          padding: 0 0.5rem;
          .card-content {
            background: @colorDark;
            border-radius: 2rem;
            border: 0.2rem solid #383241;
            box-shadow: 0 0.15rem 0 #383241;
          }
          &:nth-of-type(1) {
            .second-row {
              color: #9a6aff;
            }
          }
          &:nth-of-type(2) {
            .second-row {
              color: #5bb2da;
            }
          }
          &:nth-of-type(3) {
            .second-row {
              color: #ed4a9e;
            }
          }
        }
      }
    }
  }

  .coin-wrapper {
    margin-top: 10rem;
    .coin-content {
      background: rgba(244, 238, 255, 0.03);
      border-radius: 2rem;
      img {
        width: 14rem;
      }
      .title {
        font-size: 2rem;
      }
    }
  }

  .buy-wrapper {
    padding-top: 18rem;
    padding-bottom: 10rem;
    margin-top: 10rem;
    background-image: url('~@/assets/img/linear2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .left-box {
      width: 60%;
    }
    .right-box {
      width: 40%;
      img {
        width: 80%;
        min-width: 25rem;
        max-width: 30rem;
      }
    }
  }

  .center-wrapper {
    padding-top: 5rem;
    .center-box {
      background: linear-gradient(to bottom, #7442D7 0%, #5222B2 100%);
      .address-box {
        line-height: 1.8rem;
        /deep/ .address-copy {
          background: transparent;
          border: none;
          color: #fff;
        }
        .cover {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      /deep/ .destory-input {
        .el-input__inner {
          height: 3.4rem;
          line-height: 3.4rem;
          border-radius: 3.4rem;
          &:focus {
            border: 0.3rem solid @colorPrimary;
          }
        }
      }
    }
  }

  .guide-wrapper {
    padding-top: 10rem;
    padding-bottom: 15rem;
    .content-box {
      .text-box {
        .text-row {
          .row-title {
            display: none;
          }
        }
      }
      .line-box {
        .line-item {
          position: relative;
          &::before {
            position: absolute;
            color: @colorDeep;
            font-size: 1.6rem;
          }
          .line {
            width: 15rem;
            height: 4.7rem;
            background-image: url('~@/assets/img/line.png');
            background-size: 100% 100%;
          }
          &.tl {
            &::before {
              content: 'Step1';
              top: -2.5rem;
              left: 0;
            }
          }
          &.bl {
            margin-top: 6rem;
            .line {
              transform: rotateX(180deg);
              transform-origin: right center;
            }
            &::before {
              content: 'Step2';
              bottom: 2.5rem;
              left: 0;
              transform: translate(0, 50%);
            }
          }
          &.tr {
            .line {
              transform: rotateY(180deg);
              transform-origin: center center;
            }
            &::before {
              content: 'Step3';
              top: -2.5rem;
              right: 0;
            }
          }
          &.br {
            margin-top: 6rem;
            .line {
              transform: rotate(180deg);
              transform-origin: center center;
            }
            &::before {
              content: 'Step4';
              bottom: 2.5rem;
              right: 0;
              transform: translate(0, 50%);
            }
          }
        }
      }
      .logo-box {
        padding: 0.1rem;
        border: 0.4rem solid @colorCommon;
        border-radius: 50%;
        box-shadow: 0 0 4rem rgba(184, 173, 210, 0.3);
        .logo {
          width: 8rem;
        }
      }
    }
  }

  .art-wrapper {
    padding-top: 10rem;
    position: relative;
    &::before {
      content: '';
      width: 120%;
      height: 100%;
      position: absolute;
      left: 50%;
      top: 0;
      z-index: 1;
      background: linear-gradient(to bottom, #2a2633 0%, @colorBg 100%);
      transform: translate(-50%, 0) rotate(3deg);
      transform-origin: center;
    }
    .art-content {
      position: relative;
      z-index: 2;
      .swiper-button-next, .swiper-button-prev {
        cursor: pointer;
        background: @colorDeep;
        color: @colorWhite;
        padding: 0.2rem;
        border-radius: 0.6rem;
        &:after {
          font-size: 2.2rem;
        }
      }
    }
  }

  .rescue-wrapper {
    padding-top: 10rem;
    .left-box {
      width: 40%;
      min-width: 25rem;
      max-width: 35rem;
      .text-max {
        display: none;
      }
    }
    .right-box {
      width: 60%;
      .des {
        padding: 3rem;
        border-radius: 2rem;
        background: rgba(185, 175, 210, 0.2);
      }
    }
  }

  .community-wrapper {
    padding-top: 10rem;
    background-image: url('~@/assets/img/shadow.png');
    background-size: 100%;
    background-repeat: no-repeat;
    .content-box {
      padding: 8rem 6rem;
      background: rgba(57, 51, 70, 0.8);
      .text-box {
        padding: 0 6rem;
      }
      .recom-box {
        padding: 4rem;
        border-radius: 3rem;
        background: @colorDark;
        font-size: 1.375rem;
        .cover {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        input {
          width: 100%;
          background: transparent;
          color: @colorWhite;
        }
      }
    }
  }

  .intro-wrapper {
    padding-top: 10rem;
    padding-bottom: 10rem;
    .icon-box {
      width: 60%;
      margin: 0 auto;
      .icon-item {
        display: flex;
        align-items: center;
        justify-items: center;
        background-color: @colorCommon;
        border-radius: 50%;
        padding: 1.5rem;
        svg {
          fill: @colorDark;
        }
      }
    }
  }
}

footer {
  display: none;
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.move-enter-active, .move-leave-active {
  transition: all 0.5s;
}
.move-enter, .move-leave-to {
  margin-top: 5%;
  opacity: 0;
}

.link-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  z-index: 88;
  background: #353547;
  text-align: center;
  border-radius: 1rem;
  padding: 8rem 0 4rem;
  h3 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    font-size: 1.8rem;
    i {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-50%, -50%);
    }
  }
  ul {
    li {
      a {
        &:hover {
          color: @colorCommon;
        }
      }
    }
  }
}

.dialog-cover {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(19, 19, 20, 0.88);
  z-index: 66;
}

/deep/ .buy-button {
  padding: 0!important;
  span, a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  a {
    box-sizing: border-box;
    padding: 0 1.4rem;
  }
}
</style>
